import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "namespace-page" }
const _hoisted_2 = { class: "namespace-page__side-menu" }

import { computed, inject, onBeforeMount, provide, ref, Ref, watch } from 'vue';
import { RouterVerticalTab, RouterVerticalTabs } from '@/components';
import {
  Cog6ToothIcon,
  QueueListIcon,
  UserGroupIcon,
  UserIcon,
  RectangleStackIcon,
  ChartBarIcon,
} from 'tir-style-system/icons/outline';
import { ProjectModel } from '@/models';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { AdapterService } from '../namespace-admins-page/adapter/AdapterService';
import { useRouter } from 'vue-router';
import ShortProfile from '@/api/Main/dataSource/api/users/profile/i-service/models/ShortProfile';
import { NamespaceAdapterService } from './adapter-service';
import { NamespaceModel } from '../project-namespaces-page/models';

/**Апи сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-page',
  props: {
  userData: { type: Array<ShortProfile> },
},
  setup(__props) {

const props = __props;

const apiService = new NamespaceAdapterService();



/**Маршруты */
const router = useRouter();
/**Сервис для получения админов */
const adapter = new AdapterService();
/**Информация об области */
const namespace = ref<NamespaceModel>();

/**Информация о проекте */
const project = inject('project') as Ref<ProjectModel>;

/**Есть доступ к роуту */
const namespaceAllowed = computed(() => {
  const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);
  const isProjectAdmin = !!project.value.Admins?.some((a) => a.Id == CurrentUser.Id);
  const isNamespaceAdmin = namespaceAdmin.value;
  return isOwner || isProjectAdmin || isNamespaceAdmin;
});
/**Id рабочей области */
const namespaceId = computed(() => router.currentRoute.value.params?.namespaceId?.toString());

/**Классы элемента с контентом */
const contentClasses = computed(() => ({
  form:
    router.currentRoute.value.name == 'namespace-types' ||
    router.currentRoute.value.name == 'namespace-difficulty',
}));

/**Id админов рабочей области */
const namespaceAdminsIds = ref<number[]>([]);

provide('popover-scroll-selector', '.project-list-wrapper-content');

/**Перед рендером */
onBeforeMount(async () => {
  await getNamespace();
  await getNamespaceAdmins();

  const checkoutRoutes = [
    'namespace-settings',
    'namespace-types',
    'namespace-difficulty',
    'namespace-team',
    'namespace-admins',
  ];
  if (!namespaceAllowed.value && checkoutRoutes.includes(String(router.currentRoute.value.name))) {
    router.push('/');
  }
});

const namespaceAdmin = ref<boolean>(false);

provide('isAdminNamespace', namespaceAdmin);
/**Информация НС */
provide('namespaceInfo', namespace);

watch(
  () => router.currentRoute.value.params.namespaceId,
  async () => {
    const adminsNamespace = ref();
    const resp = await adapter.getNamespaceAdmins(namespaceId.value);
    if (resp.IsSuccess) {
      adminsNamespace.value = resp.Value.map((user) => user.Id);
    }
    namespaceAdmin.value = adminsNamespace.value.includes(CurrentUser.Id);
  },
  { immediate: true },
);

/**Получить список админов неймспейса */
const getNamespaceAdmins = async () => {
  if (!namespaceId.value) return;

  const resp = await adapter.getNamespaceAdmins(namespaceId.value);
  if (resp.IsSuccess) {
    namespaceAdminsIds.value = resp.Value.map((user) => user.Id);
  }
};
/**Получение областей */
const getNamespace = async () => {
  const response = await apiService.getNamespace(namespaceId.value);
  if (response.IsSuccess && response.Value) {
    namespace.value = response.Value;
  } else {
    router.push({
      name: 'project-stub-page',
      query: { errorCode: response.ErrorCode },
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(RouterVerticalTabs), null, {
        default: _withCtx(({ currentTab }) => [
          _createVNode(_unref(RouterVerticalTab), {
            route: { name: 'namespace-queues' },
            label: "Обзор рабочей области",
            "current-tab": currentTab
          }, {
            left: _withCtx(() => [
              _createVNode(_unref(QueueListIcon))
            ]),
            _: 2
          }, 1032, ["current-tab"]),
          (namespaceAllowed.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(RouterVerticalTab), {
                  route: { name: 'namespace-settings' },
                  label: "Основная информация",
                  "current-tab": currentTab
                }, {
                  left: _withCtx(() => [
                    _createVNode(_unref(Cog6ToothIcon))
                  ]),
                  _: 2
                }, 1032, ["current-tab"]),
                _createVNode(_unref(RouterVerticalTab), {
                  route: { name: 'namespace-admins' },
                  label: "Администраторы рабочей области",
                  "current-tab": currentTab
                }, {
                  left: _withCtx(() => [
                    _createVNode(_unref(UserIcon))
                  ]),
                  _: 2
                }, 1032, ["current-tab"]),
                _createVNode(_unref(RouterVerticalTab), {
                  route: { name: 'namespace-team' },
                  label: "Команда",
                  "current-tab": currentTab
                }, {
                  left: _withCtx(() => [
                    _createVNode(_unref(UserGroupIcon))
                  ]),
                  _: 2
                }, 1032, ["current-tab"]),
                _createVNode(_unref(RouterVerticalTab), {
                  route: { name: 'namespace-types' },
                  label: "Типы",
                  "current-tab": currentTab
                }, {
                  left: _withCtx(() => [
                    _createVNode(_unref(RectangleStackIcon))
                  ]),
                  _: 2
                }, 1032, ["current-tab"]),
                _createVNode(_unref(RouterVerticalTab), {
                  route: { name: 'namespace-difficulty' },
                  label: "Сложность",
                  "current-tab": currentTab
                }, {
                  left: _withCtx(() => [
                    _createVNode(_unref(ChartBarIcon))
                  ]),
                  _: 2
                }, 1032, ["current-tab"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["namespace-page__content", contentClasses.value])
    }, [
      _createVNode(_component_RouterView, {
        userData: __props.userData,
        namespace: namespace.value
      }, null, 8, ["userData", "namespace"])
    ], 2)
  ]))
}
}

})